import './styles.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'gatsby-plugin-react-intl';

import { intlShape } from '@prospectus/common/types/intlShape';
import ProspectusLink from '@prospectus/common/ui-strict/ProspectusLink';
import { getTopicUrl } from '@utils/topics';

function GetStarted({ primarySubject, intl }) {
  const { subject: subjectForeignKey } = primarySubject;
  const courseSubjectLabel = subjectForeignKey
    ? subjectForeignKey.labels[intl.locale]
    : primarySubject.name;

  return (
    <div className="get-started">
      <p className="title">
        <FormattedMessage
          id="prospectus.routing.getstarted.title"
          defaultMessage="Get started in {subject}"
          description="Routing get started title prefix"
          values={{
            subject: courseSubjectLabel.toLowerCase(),
          }}
        />
      </p>
      <ProspectusLink
        href={getTopicUrl(intl.locale, primarySubject.slug)}
        className="muted-link inline-link lead"
        analytics={{
          eventName: 'edx.bi.link.subject-routing.clicked',
          linkProps: {
            location: 'get-started',
            subject: primarySubject.slug,
          },
        }}
      >
        {primarySubject.numberOfCourses
          && (
          <FormattedMessage
            id="prospectus.routing.getstarted.browse.with_courses"
            defaultMessage="Browse over {numCourses} {subject} courses"
            values={{
              numCourses: primarySubject.numberOfCourses,
              subject: courseSubjectLabel.toLowerCase(),
            }}
            description="Routing get started browse label (with course count)"
          />
          )}
        {!primarySubject.numberOfCourses
        && (
        <FormattedMessage
          id="prospectus.routing.getstarted.browse"
          defaultMessage="Browse other {subject} courses"
          values={{ subject: courseSubjectLabel.toLowerCase() }}
          description="Routing get started browse label (without course count)"
        />
        )}
      </ProspectusLink>
    </div>
  );
}

GetStarted.propTypes = {
  primarySubject: PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string,
    numberOfCourses: PropTypes.number,
    subject: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
  }).isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(GetStarted);
